/* eslint-disable */
export default {
  meetingTitle: 'Réunion de {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
